import React, { useContext } from 'react'
import useRequestData from '../../hooks/useRequestData';
import { BASE_URL } from '../../constants/urls';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ComputerIcon from '@mui/icons-material/Computer';
import { FlexContainer } from '../../styles/common/FlexBox';
import { CouponsContext } from '../../context/CouponsContext';

const CountCoupons = ({totalOnline,totalOffer}) => {

  const {coupons} = useContext(CouponsContext)

  const { totalItemsOnline = 0, totalItemsOffer = 0 } = coupons;

  return (
    <FlexContainer gap={1}>
        <ComputerIcon sx={{
            color: '#102051',
            width: '20px',
        }}/> 
        {totalOnline? totalOnline : totalItemsOnline} Cupons Online |
        <LocalOfferIcon sx={{
            color: '#102051',
            width: '20px',
        }}/>
        <p>
        {totalOffer? totalOffer :totalItemsOffer} Ofertas
        </p>
    </FlexContainer>
  )
}

export default CountCoupons